import { Component, ChangeDetectionStrategy, Input, ViewChild, ElementRef, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MessageContentUnion } from '@airgram/core/types/outputs';
import { MessageSticker } from '@airgram/core/types/outputs/MessageContent';
import { FilePart } from '@airgram/web';
import { FileReaderService } from '@src/core/services';
import { MultimediaSource } from '@src/models';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-message-sticker',
  templateUrl: './message-sticker.component.html',
  styleUrls: ['../styles/message-content.scss', './message-sticker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageStickerComponent extends BaseResizableComponent {
  private readonly fileReaderService = inject(FileReaderService);

  @Input() set message(mess: MessageContentUnion | undefined) {
    this.messageSticker = mess as MessageSticker;
  }

  @ViewChild('canvasSticker') canvasSticker?: ElementRef<HTMLCanvasElement>;

  messageSticker?: MessageSticker;
  messageStickerSource?: MultimediaSource;

  override ngOnInit(): void {
    super.ngOnInit();

    this.initSticker();
  }

  private initSticker(): void {
    if (!this.messageSticker) return;

    this.fileReaderService
      .getFilePart(this.messageSticker?.sticker?.sticker)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(filePart => this.setStickerSource(filePart));
  }

  private setStickerSource(filePart?: FilePart): void {
    this.messageStickerSource = { src: this.fileReaderService.getFileSource(filePart) };
    this.cdr.markForCheck();
  }
}
